var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import Button from '../button';
import Icon from '../icon';
import SchedulePopover, { ScheduleActions } from '../schedule-popover';
import { Styled } from './style';
export var DayOfWeekEnum;
(function (DayOfWeekEnum) {
    DayOfWeekEnum["SUNDAY"] = "sun";
    DayOfWeekEnum["MONDAY"] = "mon";
    DayOfWeekEnum["TUESDAY"] = "tue";
    DayOfWeekEnum["WEDNESDAY"] = "wed";
    DayOfWeekEnum["THURSDAY"] = "thu";
    DayOfWeekEnum["FRIDAY"] = "fri";
    DayOfWeekEnum["SATURDAY"] = "sat";
})(DayOfWeekEnum || (DayOfWeekEnum = {}));
var MultilineSchedule = /** @class */ (function (_super) {
    __extends(MultilineSchedule, _super);
    function MultilineSchedule(props) {
        var _this = _super.call(this, props) || this;
        _this.getDefaultRule = function () { return ({
            time: [],
            day_of_week: {
                mon: true,
                tue: true,
                wed: true,
                thu: true,
                fri: true,
                sat: true,
                sun: true,
            },
            date: [],
            exclusive: false,
        }); };
        _this.getInitialState = function () { return ({
            scheduleList: _this.props.rules.length > 0
                ? _this.props.rules
                : [_this.getDefaultRule()],
        }); };
        _this.addItem = function () {
            var callback = _this.props.callback;
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { scheduleList: __spreadArrays(prevState.scheduleList, [
                    _this.getDefaultRule(),
                ]) })); }, function () {
                if (callback) {
                    callback(_this.state.scheduleList);
                }
            });
        };
        _this.removeItem = function (id) {
            _this.setState(function (prevState) {
                if (prevState.scheduleList.length > 1) {
                    return __assign(__assign({}, prevState), { scheduleList: prevState.scheduleList.filter(function (_, index) { return index !== id; }) });
                }
                else {
                    return __assign({}, prevState);
                }
            }, function () { return _this.props.callback && _this.props.callback(_this.state.scheduleList); });
        };
        _this.handleScheduleChange = function (index, action, data) {
            var callback = _this.props.callback;
            var scheduleList = _this.state.scheduleList;
            switch (action) {
                case ScheduleActions.ExclusiveToggled:
                    scheduleList[index].exclusive = data.checked;
                    break;
                case ScheduleActions.DayOfWeekChanged:
                    scheduleList[index].day_of_week = data.day_of_week;
                    break;
                case ScheduleActions.DateChanged:
                    scheduleList[index].date = data.date;
                    break;
                case ScheduleActions.TimeChanged:
                    scheduleList[index].time = data.time;
                    break;
                default:
                    break;
            }
            _this.setState({ scheduleList: scheduleList }, callback
                ? function () { return callback(_this.state.scheduleList); }
                : undefined);
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    MultilineSchedule.prototype.render = function () {
        var _a;
        var _this = this;
        var scheduleList = this.state.scheduleList;
        var defaultDayOfWeek = (_a = {},
            _a[DayOfWeekEnum.MONDAY] = true,
            _a[DayOfWeekEnum.TUESDAY] = true,
            _a[DayOfWeekEnum.WEDNESDAY] = true,
            _a[DayOfWeekEnum.THURSDAY] = true,
            _a[DayOfWeekEnum.FRIDAY] = true,
            _a[DayOfWeekEnum.SATURDAY] = true,
            _a[DayOfWeekEnum.SUNDAY] = true,
            _a);
        return (React.createElement(Styled, { disabled: this.props.disabled },
            React.createElement("div", { className: "item-group" }, scheduleList.map(function (rule, index) { return (React.createElement("div", { key: 'rule-' + index, className: "item-row" },
                React.createElement(SchedulePopover, { isExclusiveEnabled: rule.exclusive, time: rule.time, dayOfWeek: rule.day_of_week ? rule.day_of_week : defaultDayOfWeek, locale: _this.props.locale, date: rule.date, callback: function (action, data) { return _this.handleScheduleChange(index, action, data); } }),
                scheduleList.length > 1 &&
                    React.createElement(Button, { className: "btn-remove-item", onClick: function () {
                            _this.removeItem(index);
                        }, tabIndex: "-1", transparent: true },
                        React.createElement(Icon, { name: "remove-fill" })))); })),
            React.createElement(Button, { onClick: this.addItem, transparent: true, className: "btn-add-item" },
                React.createElement(Icon, { name: "plus-fill" }))));
    };
    MultilineSchedule.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.scheduleList === nextProps.rules) {
            return {
                scheduleList: nextProps.rules,
            };
        }
        return null;
    };
    return MultilineSchedule;
}(React.Component));
export default MultilineSchedule;
//# sourceMappingURL=index.js.map